export default __webpack_public_path__ + "static/2016_2017_WVS INDIA CONSOLIDATED ACCOUNTS-a32bb852ec2cdfbb88fcf226c5db2010.pdf";